import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState, useRef } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash'; // import cx from 'classnames'

import i18n from 'i18next';
import { useSelector, useDispatch } from 'react-redux';
import DropDown from '../ui/react-ui/dropdown';
import DataTable from '../ui/table';
import MapeRoadSectionChart from './mape-roadSection-chart'; // api

import { getMapeRoadSectionByWeek } from '../../api/mapeAPI'; // redux

import { setRoadSectionId, setRoadSectionByWeek } from '../../redux/setting-mape';
var t = i18n.getFixedT(null, 'setting-mape');
var MapeRoadSection = /*#__PURE__*/React.memo(function (props) {
  // redux
  var _useSelector = useSelector(function (state) {
    return state.toJS();
  }),
      contextRoot = _useSelector.envCfg.contextRoot,
      _useSelector$mape = _useSelector.mape,
      dateRange = _useSelector$mape.dateRange,
      roadSectionList = _useSelector$mape.roadSectionList,
      roadSectionId = _useSelector$mape.roadSectionId,
      roadSectionMapeData = _useSelector$mape.roadSectionMapeData;

  var dispatch = useDispatch();

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      roadSectionData = _useState2[0],
      setRoadSectionData = _useState2[1];

  var isMounted = useRef();
  var id = props.id,
      predictionType = props.predictionType;

  var handleDropDownChange = function handleDropDownChange(val) {
    dispatch(setRoadSectionId(val));
  };

  useEffect(function () {
    if (!isMounted.current) return;
    getMapeRoadSectionByWeek(contextRoot, false, dateRange, predictionType, roadSectionId).then(function (result) {
      var mapeRoadSectionByWeek = _.cloneDeep(result.content).sort(function (a, b) {
        return a.day - b.day;
      });

      mapeRoadSectionByWeek.unshift(mapeRoadSectionByWeek.pop());
      dispatch(setRoadSectionByWeek(mapeRoadSectionByWeek));
    });
  }, [roadSectionId]);
  useEffect(function () {
    if (roadSectionList.length === 0) return;

    var newData = _.cloneDeep(roadSectionList);

    _.map(roadSectionMapeData, function (el) {
      var item = _.find(newData, function (o) {
        return o.value === el.roadSectionId;
      });

      if (!_.isEmpty(item)) item.mape = Math.round(el.mape * 100 * 10) / 10;
    });

    setRoadSectionData(newData);
  }, [JSON.stringify(roadSectionMapeData), JSON.stringify(roadSectionList)]);
  useEffect(function () {
    if (!isMounted.current) {
      isMounted.current = true;
    }

    return function () {
      setRoadSectionData([]);
    };
  }, []);
  if (!isMounted.current) return null;
  var fieldsLeft = {};

  _.set(fieldsLeft, 'text', {
    label: t('lbl-road-area')
  });

  _.set(fieldsLeft, 'mape', {
    label: t('lbl-mape'),
    formatter: function formatter(val, row) {
      return /*#__PURE__*/React.createElement("span", {
        className: parseInt(val) > 20 ? 'high' : ''
      }, val ? val + '%' : '');
    }
  });

  var fieldRight = {};

  _.set(fieldRight, 'text', {
    label: t('lbl-model')
  });

  _.set(fieldRight, 'avgVehicleVolumes', {
    label: t('lbl-car-count')
  });

  return /*#__PURE__*/React.createElement("div", {
    id: id,
    className: "mape-card-block"
  }, /*#__PURE__*/React.createElement("div", {
    className: "head"
  }, /*#__PURE__*/React.createElement("span", {
    className: "title"
  }, t('lbl-road-section')), /*#__PURE__*/React.createElement("div", {
    className: "selector"
  }, /*#__PURE__*/React.createElement("label", {
    className: "label"
  }, t('lbl-road-area'), ": "), /*#__PURE__*/React.createElement(DropDown, {
    defaultText: t('lbl-all-road-area'),
    list: roadSectionList,
    value: roadSectionId,
    onChange: function onChange(val) {
      return handleDropDownChange(val);
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: "content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "c-border c-position-rlt dataTable-wrap"
  }, /*#__PURE__*/React.createElement(DataTable, {
    fields: fieldsLeft,
    data: roadSectionData
  })), /*#__PURE__*/React.createElement(MapeRoadSectionChart, null)));
});
MapeRoadSection.defaultProps = {
  id: 'g-mape-roadSection'
};
MapeRoadSection.PropTypes = {
  id: PropTypes.string
};
export default MapeRoadSection;